<template>
  <div class="flex items-start">
    <div class="w-full">
      <vs-textarea
        name="text-body"
        class="m-0"
        v-model="textBody"
        v-validate="'required'"
        ref="textarea"
        :height="''"
        :class="isEditedClass(textBody, this.template.body)"
      />
      <span class="text-danger text-sm" v-show="errors.has('text-body')">{{ errors.first('text-body') }}</span>
    </div>
    <TemplateButtons
      :show-save-button="isReadyToSave"
      @save="handleClickOnSave"
      @delete="handleClickOnDelete"
    />
  </div>
</template>

<script>
import autosize from 'autosize'
import TemplateButtons from './TemplateButtons'
import { isEditedClass } from '../../../../helpers/helpers'

export default {
  props: {
    template: {
      type: Object,
      required: true
    }
  },
  components: {
    TemplateButtons
  },
  data () {
    return {
      textBody: this.template.body,
      $textarea: null
    }
  },
  mounted () {
    this.$textarea = this.$refs.textarea.$el.children[0]
    autosize(this.$textarea)
  },
  computed: {
    isReadyToSave () {
      return this.template.body !== this.textBody
    }
  },
  methods: {
    isEditedClass,
    async handleClickOnSave () {
      const validate = await this.$validator.validateAll()
      if (validate) {
        this.textBody = this.textBody.trim()
        await this.$emit('save', {
          id: this.template.id,
          new: this.template.new || false,
          message_type: 'text',
          body: this.textBody
        })
        autosize.update(this.$textarea)
      }
    },
    async handleClickOnDelete () {
      this.$emit('delete', {
        id: this.template.id,
        new: this.template.new || false
      })
    }
  }
}
</script>
